/*
 * Custom "4 people" and "2 people" icons.
 * Match the stroke style of lucide-react icons (round linecap/linejoin, 24x24 viewBox).
 */

const base = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

export function UsersFour({ size = 24, strokeWidth = 1.5, style, className }) {
  return (
    <svg
      {...base}
      width={size}
      height={size}
      strokeWidth={strokeWidth}
      style={style}
      className={className}
    >
      {/* Back row: two heads */}
      <circle cx="7" cy="6" r="2.2" />
      <circle cx="17" cy="6" r="2.2" />
      {/* Back row: two small shoulders */}
      <path d="M3 12c0-2 1.8-3.2 4-3.2s4 1.2 4 3.2" />
      <path d="M13 12c0-2 1.8-3.2 4-3.2s4 1.2 4 3.2" />
      {/* Front row: two heads (slightly bigger) */}
      <circle cx="8.5" cy="14.5" r="2.4" />
      <circle cx="15.5" cy="14.5" r="2.4" />
      {/* Front row: shoulders */}
      <path d="M4 21.5c0-2.4 2-4 4.5-4s4.5 1.6 4.5 4" />
      <path d="M11 21.5c0-2.4 2-4 4.5-4s4.5 1.6 4.5 4" />
    </svg>
  );
}

export function UsersTwo({ size = 24, strokeWidth = 1.5, style, className }) {
  return (
    <svg
      {...base}
      width={size}
      height={size}
      strokeWidth={strokeWidth}
      style={style}
      className={className}
    >
      {/* Left person */}
      <circle cx="8" cy="8" r="3" />
      <path d="M2.5 20c0-3 2.5-5 5.5-5s5.5 2 5.5 5" />
      {/* Right person */}
      <circle cx="16.5" cy="8" r="3" />
      <path d="M11 20c0-3 2.5-5 5.5-5s5.5 2 5.5 5" />
    </svg>
  );
}

export function VintageMegaphone({ size = 24, strokeWidth = 1.5, style, className }) {
  return (
    <svg
      {...base}
      width={size}
      height={size}
      strokeWidth={strokeWidth}
      style={style}
      className={className}
    >
      {/* Handle (small vertical grip under the cone) */}
      <path d="M4 14h2v4a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-4" />
      {/* Conical body: short mouth on the left, wide bell on the right */}
      <path d="M4 10v4h5l10 5V5L9 10H4z" />
    </svg>
  );
}
